// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Vision = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width={size}
      height={size}
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <path d='M46,24.5v-1.9c0-4.4-.4-5.5-2.5-5.4H4.1c-2.1.1-2.1,2.4-2.1,6.5v1.3c0,3.7,0,5.4,2.1,5.8h39.3c2.6-.3,2.6-1,2.6-6.2ZM13.6,28.8c-2.5,0-4.6-2.1-4.6-4.8s2-4.7,4.6-4.8c2.6,0,4.6,2.1,4.6,4.8s-2.1,4.8-4.6,4.8ZM34.4,28.7c-2.5,0-4.6-2.1-4.6-4.8s2-4.7,4.6-4.8c2.6,0,4.6,2.1,4.6,4.8s-2.1,4.8-4.6,4.8Z' />
    </svg>
  );
};
